var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"message-status"},[(_vm.isSending)?_c('b-spinner',{attrs:{"small":""}}):_vm._e(),_c('span',{class:{ 'sending-text': _vm.isSending }},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }